import { render } from "./PartsDashboardTable.vue?vue&type=template&id=26b277e2&scoped=true"
import script from "./PartsDashboardTable.vue?vue&type=script&lang=js"
export * from "./PartsDashboardTable.vue?vue&type=script&lang=js"

import "./PartsDashboardTable.vue?vue&type=style&index=0&id=26b277e2&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-26b277e2"]])

export default __exports__